import { render, staticRenderFns } from "./FinishedLoansTable.vue?vue&type=template&id=226fff75&scoped=true"
import script from "./FinishedLoansTable.vue?vue&type=script&lang=js"
export * from "./FinishedLoansTable.vue?vue&type=script&lang=js"
import style0 from "./FinishedLoansTable.vue?vue&type=style&index=0&id=226fff75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fff75",
  null
  
)

export default component.exports